export default "/_next/static/src/assets/videos/5ab269ddc8d75328e1ba26defae5630d.mp4";